import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Pending } from '@bounded/ui/pending';
import { useT } from '../i18n';

function NotFound() {
  const t = useT();
  return <main className="p-10"><h1 className="text-xl font-semibold">{t.notFound.title}</h1><p className="text-graphite">{t.notFound.body} <Link to="/" className="text-boundary hover:underline">{t.nav.overview}</Link></p></main>;
}
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Outlet,
  pendingComponent: Pending,
  notFoundComponent: NotFound,
});
